import { CancellationPayment } from './payments';
import { client } from './claims';

export interface WorldpayCheckoutConfig {
  enabled: boolean;
  environment: 'try' | 'live';
  checkoutId?: string;
}
export interface WorldpayCheckoutAttempt {
  id: string;
  reference: string;
  amountPaid: number;
  isFinal: boolean;
  environment: 'try' | 'live';
  state: string;
  outcome?: string;
  message?: string;
  paymentRecorded: boolean;
}
interface AttemptResponse { attempt: WorldpayCheckoutAttempt }
const base = '/ui/admin/cancellation-payments';
const attemptPath = (paymentId: string) => `${base}/${encodeURIComponent(paymentId)}/worldpay-checkout/attempt`;
export const getWorldpayCheckoutConfig = async (): Promise<WorldpayCheckoutConfig> =>
  (await client.get<WorldpayCheckoutConfig>(`${base}/worldpay-checkout/config`)).data;
export const getCheckoutAttempt = async (paymentId: string): Promise<{ attempt: WorldpayCheckoutAttempt | null }> =>
  (await client.get<{ attempt: WorldpayCheckoutAttempt | null }>(attemptPath(paymentId))).data;
export const createCheckoutAttempt = async (paymentId: string, data: { amountPaid: number; isFinal: boolean; notes?: string }): Promise<AttemptResponse> =>
  (await client.post<AttemptResponse>(attemptPath(paymentId), data)).data;
export const payCheckoutAttempt = async (paymentId: string, attemptId: string, data: { sessionHref: string; cardHolderName: string }): Promise<AttemptResponse> =>
  (await client.post<AttemptResponse>(`${attemptPath(paymentId)}/${encodeURIComponent(attemptId)}/pay`, data)).data;
export const checkCheckoutAttempt = async (paymentId: string, attemptId: string): Promise<AttemptResponse> =>
  (await client.post<AttemptResponse>(`${attemptPath(paymentId)}/${encodeURIComponent(attemptId)}/check`, {})).data;

export const getCheckoutPayment = async (paymentId: string): Promise<CancellationPayment> =>
  (await client.get<{ payment: CancellationPayment }>(`${base}/${encodeURIComponent(paymentId)}/worldpay-checkout/payment`)).data.payment;
